import { format as formatFn } from 'date-fns';

export const formatDate = (value: string, format = 'yyyy-MM-dd HH:mm') => {
  const date = new Date(value);

  return formatFn(date, format);
};
